
import React from 'react';
import { useDispatch } from 'react-redux';

import projectGetActions from '../../sagas/project';

import { getVersionString } from '../../utils';
import { PAGE_USEK_INPUT, redirectToPage } from '../pagesDefinition';
import LandingPageView from './LandingPage.view';

const LandingPageState = (props) => {

    const dispatch = useDispatch();
    const projectActions = projectGetActions(dispatch);

    const handleNewCalcClick = () => {
        redirectToPage(PAGE_USEK_INPUT);
    }

    const handleOpenProject = (file) => {
        let reader = new FileReader();
        reader.onload = () => {
            let data = reader.result;
            projectActions.readProject(data);
            redirectToPage(PAGE_USEK_INPUT);
        };
        reader.readAsText(file);
    }

    return (
        <LandingPageView
            onNewCalcClick={handleNewCalcClick}
            onProcessOpenFile={handleOpenProject}
            version={getVersionString()}
        />
    )
}

export default LandingPageState;
